// extracted by mini-css-extract-plugin
export default {"filteredCount":"AssetCount_filteredCount__pF-gP"};